import React from "react"

const loaderImg = require('./ajax-loader-small.gif');

export default function Loader() {
    return (
        <img alt='Loading...' src={loaderImg}/>
    )
}
